import { useCallback, useMemo } from "react";
import { useController } from "react-hook-form";
import ColorPicker from "../../components/ColorPicker";
import { useTranslation } from "react-i18next";

const BookChapterColorField = () => {
    const { field: { value: chapterColor, onChange } } = useController({ name: 'additionalInfo.chapterColor' });
    const { t } = useTranslation();

    return (
        <ColorPicker
            isShort
            value={chapterColor}
            onChange={(val: string) => onChange(val)}
            label={t(`project_edit.settings_block.picker_labels.chapterColor`)}
            isProDeziiign
            customAlignItems="flex-start"
        />
    )
}

export default BookChapterColorField;import { useCallback, useMemo } from "react";
import { useController } from "react-hook-form";
import ColorPicker from "../../components/ColorPicker";
import { useTranslation } from "react-i18next";

const BookChapterColorField = () => {
    const { field: { value: chapterColor, onChange } } = useController({ name: 'additionalInfo.chapterColor' });
    const { t } = useTranslation();

    return (
        <ColorPicker
            isShort
            value={chapterColor}
            onChange={(val: string) => onChange(val)}
            label={t(`project_edit.settings_block.picker_labels.chapterColor`)}
            isProDeziiign
            customAlignItems="flex-start"
        />
    )
}

export default BookChapterColorField;